import { render, staticRenderFns } from "./ChangeStatusComponent.vue?vue&type=template&id=192a30e2&scoped=true"
import script from "./ChangeStatusComponent.vue?vue&type=script&lang=js"
export * from "./ChangeStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a30e2",
  null
  
)

export default component.exports